<template>
	<div class="OpenAccountBox">
		<div class="OpenAccountBoxTop">
			<div class="TitleLeft">
				关联申明
			</div>
			<div class="Btn">
				<Btn btnType="btn" backgroundColor="#E71D43" width="92px" height="32px" :title="titleBtn" :useAutoOptional="false"
					color="#FFFFFF" @btnclick="SubmitFreview"></Btn>
			</div>
			<div class="TitleRight" v-if="Status.UploadFileStatus == 1">
				. 未审核
			</div>
			<!-- <div class="TitleRight" style="color: #424E66;" v-if="Status.UploadFileStatus == 1">
        . 审核中
      </div> -->
			<div class="TitleRight" style="color: #00266d;" v-if="Status.SucceeStatus == 2">
				<div class="spotimg"></div> 审核成功
			</div>
			<div class="TitleRight" style="color: rgb(231, 29, 67);" v-if="Status.SucceeStatus == -1">
				<div class="spotimgerror"></div> 已驳回
			</div>
		</div>
		<div class="TopLine"></div>
		<div class="result" v-if="RejectReason != null">
			<div class="reason">驳回原因</div>
			<div class="reasonText">
				{{ RejectReason }}
			</div>
		</div>
		<Procedure :Status="Status"></Procedure>
		<DowloadTemplate :DowloadTemplateList="DowloadTemplateList"></DowloadTemplate>
		<div class="Upload">
			<div class="UploadTitle">
				上传附件
			</div>
			<div class="Enclosure">
				<CommonUploadEnclosure @getFiles="getFileDsphImg" types="multiple*" style="height: 120px;" title="">
				</CommonUploadEnclosure>
			</div>
			<div class="Remarks">
				支持上传文件附件及图片格式文件，最大支持5M
			</div>
		</div>
		<div class="fileList">
			<div class="file" v-for="(item , index) of AccountImgArr" :key="index">
				<div class="fileName" :title="item.FileName">{{item.FileName}}</div>
				<div class="cz">
					<div class="fileSee" @click="FileSeeClick(item)">查看</div>
					<div class="fileDel" @click="FileDelClick(index)">删除</div>
				</div>
			</div>
		</div>
		<div class="line"></div>

		<Picturepreview :show="showImg" :imgsrc="imgsrc" @hidefn="hidefn"></Picturepreview>
		<TipsDialog ref="tipsdig" />
	</div>
</template>

<script>
	import Procedure from './components/procedure.vue'
	import CommonUploadEnclosure from '@/components/common-upload-Enclosure.vue'
	import Btn from '@/components/common-btn'
	import Picturepreview from '@/components/picturepreview.vue'
	import DowloadTemplate from '../components/DowloadTemplate.vue'
	import TipsDialog from '../../components/TipsDialog.vue'
	import {
		OpenAccountAddAffiliateStatement,
		OpenAccountGetAffiliateStatement,
		OpenAccountUpLoadAttachment,
		OpenAccountDownloadAffiliateStatementTemplet
	} from '@/api/channel'
	export default {
		components: {
			Procedure,
			CommonUploadEnclosure,
			Btn,
			Picturepreview,
			DowloadTemplate,
			TipsDialog
		},
		props: {},
		data() {
			return {
				AccountImgArr: [],
				DowloadTemplateList: [], //模板下载数据
				imgsrc: '',
				titleBtn: 'loading...',
				showImg: false,
				RejectReason: '',
				Status: {
					UploadFileStatus: 0,
					ExamineStatus: 0,
					SucceeStatus: 0,
				}
			}
		},
		created() {
			this.OpenAccountGetAffiliateStatement()
			this.OpenAccountDownloadAffiliateStatementTemplet()
		},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			// 模板下载
			async OpenAccountDownloadAffiliateStatementTemplet() {
				let {
					code,
					data,
					message
				} = await OpenAccountDownloadAffiliateStatementTemplet({})
				if (code == 0) {
					this.DowloadTemplateList = data
				} else {
					this.$message.warning('模板列表加载失败')
				}
			},
			async OpenAccountGetAffiliateStatement() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await OpenAccountGetAffiliateStatement({})
				if (code == 0) {
					if (data != null) {
						this.AccountImgArr = data.lstAttachment
						if (data.Status == 0) {
							this.Status.UploadFileStatus = 1
							this.Status.ExamineStatus = 0
							this.Status.SucceeStatus = 0
							console.log(this.Status);
						} else if (data.Status == 1) {
							this.Status.UploadFileStatus = 2
							this.Status.ExamineStatus = 2
							this.Status.SucceeStatus = 2
						} else if (data.Status == -1) {
							this.Status.UploadFileStatus = 2
							this.Status.ExamineStatus = 2
							this.Status.SucceeStatus = -1
						}
						this.RejectReason = data.RejectReason
						this.titleBtn = '提交'
					} else {
						this.Status.UploadFileStatus = 1
						this.Status.ExamineStatus = 0
						this.Status.SucceeStatus = 0
						this.titleBtn = '提交审核'
					}
				} else {
					this.$notify({
						title: '提示',
						type: 'warning',
						message: message
					})
				}
				loading.close()
			},
			// 上传
			async OpenAccountUpLoadAttachment(file) {
				const loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				for (var i = 0; i < file.length; i++) {
					formdata.append("files", file[i]);
				}
				let {
					data,
					code,
					message
				} = await OpenAccountUpLoadAttachment(formdata)
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});

					if (code == 0) {
						data.forEach(item => {
							if (!this.AccountImgArr.includes(item)) {
								this.AccountImgArr.push(item)
							}
						});
					}
					loading.close();
					return
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
					loading.close();
					return
				} else {
					// this.dialogVisiblesdrjg = true
					// this.tableDatadrjg = data
					// this.title = "上传结果"
					this.$message({
						type: 'error',
						message: message
					});
					loading.close();
				}

			},
			// 提交
			async OpenAccountAddAffiliateStatement() {
				let AccountImgArr = []
				this.AccountImgArr.forEach((item, index) => {
					AccountImgArr.push(item.FileName)
				})
				let {
					code,
					data,
					message
				} = await OpenAccountAddAffiliateStatement({
					fileNames: AccountImgArr
				})
				if (code == 0) {
					this.$notify({
						title: '提示',
						type: 'success',
						message: message
					})
					this.$refs.tipsdig.getData();
					this.OpenAccountGetAffiliateStatement()
				} else {
					this.$notify({
						title: '提示',
						type: 'warning',
						message: message
					})
				}
			},
			getFileDsphImg(file) {
				this.OpenAccountUpLoadAttachment(file)
			},
			SubmitFreview() {
				this.OpenAccountAddAffiliateStatement()
			},
			FileSeeClick(item) {
				console.log(item);
				if (item.Extension == 'jpg' || item.Extension == 'png' || item.Extension == 'gif') {
					this.showImg = true
					this.imgsrc = item.FilePath
				} else {
					window.location.href = item.FilePath
				}
			},
			FileDelClick(index) {
				this.AccountImgArr.splice(index, 1)
			},
			hidefn() {
				this.showImg = false
			}
		},
		computed: {},
		watch: {},
	}
</script>
<style scoped lang='less'>
	.spotimg {
		display: inline-block;
		width: 12.5px;
		height: 10px;
		position: relative;
		right: 5px;
		bottom: 0px;
		background: url("../../../../../assets/channel/menu/OK2.png") no-repeat 0px 0px;
		background-size: 100%;
	}

	.spotimgerror {
		display: inline-block;
		width: 12.5px;
		height: 10px;
		position: relative;
		right: 5px;
		bottom: 0px;
		background: url("../../../../../assets/channel/menu/error1.png") no-repeat 0px 0px;
		background-size: 100%;
	}

	.OpenAccountBox {
		height: 100%;
		width: 910px;
		margin: 0 auto;

		.result {
			width: 100%;

			.reason {
				color: #16181a;
				font-size: 14px;
				font-weight: 500;
				margin: 9px;
			}

			.reasonText {
				width: 872px;
				// height: 32px;
				margin: 0 auto;
				background-color: #fef8f9;
				border: 1px solid #ebedf0;
				color: #e71d43;
				line-height: 32px;
				padding-left: 20px;
				margin-bottom: 30px;
				word-wrap: break-word;
			}
		}

		.OpenAccountBoxTop {
			height: 70px;
			width: 100%;
			position: relative;
			border-bottom: 1px solid #eaecef;


			.TitleLeft {
				height: 45px;
				width: 100%;
				line-height: 45px;
				font-size: 16px;
				font-weight: 500;
				display: inline;
				color: #16181a;
			}

			.TitleRight {
				height: 45px;
				width: 95px;
				line-height: 45px;
				font-size: 14px;
				font-weight: 500;
				color: #9ca5b7;
				position: absolute;
				top: 0;
				right: -30px;
			}
		}

		.fileList {
			width: 100%;
			height: 100%;
			// border: 1px solid red;
			margin-top: 30px;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.file {
				line-height: 32px;
				border-radius: 2px;
				border: 1px solid #e6e6e6;
				cursor: pointer;
				display: inline-block;
				position: relative;
				width: 440px;
				height: 32px;
				color: #000000;
				font-size: 12px;
				background-color: #fafbfc;
				margin-top: 10px;

				.fileName {
					display: inline-block;
					font-size: 14px;
					margin-left: 20px;
					max-width: 320px;
					// border: 1px solid red;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				.cz {
					display: flex;
					width: 90px;
					font-size: 14px;
					float: right;
					color: #e71d43;

					.fileSee {
						display: inline-block;
						margin-left: 10px;
					}

					.fileDel {
						display: inline-block;
						margin-left: 10px;
					}
				}
			}
		}
	}

	.Upload {
		height: 100%;
		width: 100%;
		//   border: 1px solid red;
		margin-top: 30px;

		.UploadTitle {
			font-size: 14px;
			font-weight: normal;
			color: #424e66;
		}

		.Enclosure {
			margin-left: -45px;
		}

		.Remarks {
			font-size: 14px;
			font-weight: normal;
			color: #9ca5b7;
		}
	}

	.line {
		width: 100%;
		height: 1px;
		background: #eaecef;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		margin-top: 30px;
	}

	.Btn {
		margin-right: 700px;
		display: inline;
	}
</style>
